// extracted by mini-css-extract-plugin
module.exports = {"container":"MultiMoveCollations_container__y6rz6","selectedBadge":"MultiMoveCollations_selectedBadge__1_3iQ"};